import { Capacitor } from '@capacitor/core';

/**
 * Printing opens a new window, which the native apps can't do (Capacitor hands
 * new windows to Safari, and WKWebView has no window.print). So print buttons
 * are web-only; the apps offer share/export instead.
 */
export const CAN_PRINT = !Capacitor.isNativePlatform();

/** Open a print-ready window with the given HTML body (desktop). */
export function printHtml(title: string, body: string, extraCss = ''): boolean {
  const w = window.open('', '_blank');
  if (!w) return false;
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${title.replace(/</g, '&lt;')}</title><style>
@page{margin:0.5in}body{font-family:system-ui,-apple-system,sans-serif;color:#000;margin:0;font-size:12px}
h1{font-size:18px;margin:0 0 2px}h2{font-size:13px;margin:12px 0 4px}.muted{color:#555}
table{border-collapse:collapse;width:100%}th,td{border:1px solid #999;padding:4px 6px;text-align:left;vertical-align:top}th{background:#eee}
.badge{display:inline-block;border-radius:4px;padding:1px 5px;font-size:10px;font-weight:bold;color:#fff}
.chip{display:inline-block;border:1px solid #999;border-radius:8px;padding:0 5px;font-size:10px;margin-right:3px}
${extraCss}</style></head><body>${body}<script>onload=()=>setTimeout(()=>print(),150)</script></body></html>`);
  w.document.close();
  return true;
}
export function esc(s: unknown): string {
  return String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]!);
}
